<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList" :isLimit="false">
      <div slot="import-config">
        <el-form-item label="自动传GET参数">
          <el-radio class="radio" v-model="form.is_query" :label="1">开启</el-radio>
          <el-radio class="radio" v-model="form.is_query" :label="0">关闭</el-radio>
        </el-form-item>
        <div class='block p-20 pos-rel' style="width: 570px">
          
          <div class='tit'>基础配置</div>
          <el-form-item label="工作表名" prop='sheet_name'>
            <el-input v-model.trim="form.sheet_name" class="h-40 w-200"></el-input>
          </el-form-item>
          <el-form-item label="起始导入行数" prop='first_import'>
            <el-input v-model.trim="form.first_import" class="h-40 w-200"></el-input>
          </el-form-item>
          <el-form-item label="导入文件大小限制（单位MB，0为不限制）" prop='limit_size'>
            <el-input v-model.trim="form.limit_size" class="h-40 w-200"></el-input>
          </el-form-item>
          <el-form-item label="导入模版上传（不上传则不显示模版下载）">
            <el-upload
              ref='fileupload'
              class="upload-demo"
              :action="fileUrl"
              :before-upload="beforeUpload"
              :on-success='successCb'
              :on-remove='removeCb'
              :file-list='fileList'>
              <el-button size="small" type="primary">{{upload_name}}</el-button>
              <div slot="tip" class="el-upload__tip">只支持xlsx上传文件</div>
            </el-upload>
            <a :href="form.template_url" class="downloadBtn" v-show="fileList.length>0">下载模版</a>
          </el-form-item>
          <el-form-item label="表头校验（校验表头内容，以避免导入错误模版，可不填）">
            <el-table
            :data="form.title_config"
            border
            style="width: 561px">
              <el-table-column
                label="列（数字列标号）"
                width="150">
                <template scope="scope">
                  <el-input v-model.trim="scope.row.col" class="h-40" placeholder='请输入大写字母'></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="行数（数字行标号）"
                width="170">
                <template scope="scope">
                  <el-input v-model.trim="scope.row.row" class="h-40" placeholder='请输入'></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="内容"
                width="160">
                <template scope="scope">
                  <el-input v-model.trim="scope.row.content" class="h-40" placeholder='请输入'></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="80">
                <template scope="scope">
                  <el-button type="text" size="small" @click="deleteTitleConfig(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class='m-t-10 m-b-10'>
              <el-button type="primary" @click="addTitleConfig">添加</el-button>
            </div>
          </el-form-item>
        </div>
      
        <div class='block p-20 pos-rel m-t-30' style="width: 935px">
          <div class='tit'>数据配置</div>
          <el-button type="primary" @click="getAllfields">获取所有字段</el-button>
          <el-form-item label="">
            <el-table
            :data="form.import_fields"
            border
            style="width: 931px">
              <el-table-column
                label="选择字段"
                width="160">
                <template scope="scope">
                  <dropdown-input
                  :inputSource="selectFormFields"
                  :value="formFieldsLabels[scope.row.field_id]['value']"
                  :placeholder="请输入内容"
                  :listIndex="scope.$index"
                  @handleSelectField="handleSelectField"
                  v-if="formFieldsLabels[scope.row.field_id]"
                  ></dropdown-input>
                  <dropdown-input
                  :inputSource="selectFormFields"
                  :value="nullVal"
                  :placeholder="请输入内容"
                  :listIndex="scope.$index"
                  @handleSelectField="handleSelectField"
                  v-else>
                  </dropdown-input>
                </template>
              </el-table-column>
              <el-table-column
                label="字段类型及配置"
                width="170">
                <template scope="scope">
                  <span>{{ scope.row.type }}</span>
                  <el-button 
                    type="text"
                    class='config' 
                    v-if='isStruct(scope.row.fieldtype_id) || isForeign(scope.row.fieldtype_id) || isUser(scope.row.fieldtype_id)' 
                    @click='configOperation(scope.row, scope.$index)'>
                    配置
                  </el-button>
                  <el-button 
                    type="text"
                    class='config' 
                    v-if='isKey(scope.row.fieldtype_id) && scope.row.has_config' 
                    @click='configOperation(scope.row, scope.$index)'>
                    配置
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="对应导入列 (多列考虑用;号分隔开，合并列用&连接)"
                width="260">
                <template scope="scope">
                  <el-input v-model.trim="scope.row.col" class="h-40" placeholder='请输入'></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="数据清洗"
                width="260">
                <template scope="scope">
                  <el-tag type="danger" v-for="(tag, tindex) in scope.row.deal_type">{{ tempDealTypes[tag]["name"] }}</el-tag>
                  <el-button type="text" class="m-l-10" size="small" @click="selectCleanType(scope.$index)">选择</el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="80">
                <template scope="scope">
                  <el-button type="text" size="small" @click="deleteImportConfig(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class='m-t-10 m-b-10'>
              <el-button type="primary" @click="addImportConfigObj">添加</el-button>
            </div>
          </el-form-item>
        </div>
        
        <div class='block p-20 pos-rel m-t-30' style="width: 560px">
          <div class='tit'>数据已存在校验配置</div>
          <el-form-item label="是否开启数据已存在校验">
            <el-radio class="radio" v-model="form.is_unique" label="1">是</el-radio>
            <el-radio class="radio" v-model="form.is_unique" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="是否开启数据已存在校验" v-if='form.is_unique == "1"'>
            <el-radio class="radio" v-model="form.check_type" label=10>AND（需多个字段同时存在）</el-radio>
            <el-radio class="radio" v-model="form.check_type" label=20>OR（按优先度判断）</el-radio>
          </el-form-item>
          <el-form-item label="校验字段" v-if='form.is_unique == "1"'>
            <el-table
            :data="form.unique_config"
            border
            style="width: 100%">
            <el-table-column
              label="优先度"
              width="120">
              <template scope="scope">
                <el-button v-if="scope.$index != 0" size="mini" @click="moveTr(scope.$index, 0)">上移</el-button>
                <el-button v-if="scope.$index != form.unique_config.length - 1" size="mini" @click="moveTr(scope.$index, 1)">下移</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="选择字段">
              <template scope="scope">
                <el-select filterable v-model="scope.row.field_id" size="small">
                  <el-option
                    v-for="item in formFields"
                    :label="item.default.title"
                    :value="item.default.field_id">
                    <!-- <span>{{ item.field }}（{{ item.title }}）</span> -->
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="70">
              <template scope="scope">
                <el-button type="text" size="small" @click="deleteUnique(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="m-t-10" >
            <el-button type="info" @click="addUnique()">添加</el-button>
          </div>
          </el-form-item>
          <el-form-item label="数据已存在的处理方式" v-if='form.is_unique == "1"'>
            <el-radio 
            class="radio uniqueRadio" 
            v-model="form.unique_type" 
            v-for='type in uniqueTypes' 
            :label="type.id">
            {{type.name}}
            </el-radio>
          </el-form-item>
          <el-form-item label="请选择选中字段" v-if='uniqueFieldShow'>
            <el-select filterable v-model="form.unique_over_fields" multiple placeholder="请选择字段">
              <el-option
              v-for="item in formFields"
              :label="item.default.title"
              :value="item.default.field_id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class='block p-20 pos-rel m-t-30' style="width: 560px">
          <div class='tit'>导入记录配置</div>
          <el-form-item label="是否开启导入记录">
            <el-radio class="radio" v-model="form.is_report" label="1">是</el-radio>
            <el-radio class="radio" v-model="form.is_report" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="记录内容" v-if='form.is_report == "1"'>
            <el-checkbox v-model="form.isAll" @change="isAllSelect">全部</el-checkbox>
            <el-checkbox-group v-model="form.report_type" @change="handleReportTypeChange">
              <el-checkbox 
              v-for="type in contentTypes" 
              :label="type.id" 
              :key="type.id">
              {{type.name}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="请选择导入数据的字段" v-if='fieldShow && form.is_report == "1"'>
            <el-select v-model="form.report_fields" multiple placeholder="请选择字段">
              <el-option
              v-for="item in formFields"
              :label="item.default.title"
              :value="item.default.field_id">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="查看记录的权限规则绑定" v-if='form.is_report == "1"'>
            <el-input v-model.trim="form.report_ruleName" class="h-40 fl w-200" :disabled="true"></el-input>
            <el-button class="fl m-l-30" v-if='form.report_ruleName == ""' @click="openRule()">查找</el-button>
            <el-button class="fl m-l-10" v-else @click="clearRule()">清空</el-button>
          </el-form-item>
        </div>
      </div>
    </common-config>
    <rule-list ref="ruleList" @selectRule="selectRule"></rule-list>
    <cleantype-dialog 
      ref="cleantype" 
      :dealTypesSource="dealTypes"
      :curDealType="curDealType"
      :curfieldsIndex="curfieldsIndex"
      @setCleanType="setCleanType">
    </cleantype-dialog>
    <config-operation
      ref="configOperation"
      :curConfigData="curConfigData"
      @confirmConfigOperation="confirmConfigOperation"
      >
    </config-operation>
  </div>
</template>
<style scoped>
  .uniqueRadio{
    display: block;
    margin-left: 0px !important;
  }
  .block{
    border: 1px solid #ccc;
  }
  .tit{
    position: absolute;
    top: -11px;
    background: #f1f2f7;
  }
  .config{
    color: #20A0FF;
    margin-left: 15px;
  }
  .downloadBtn{
    padding:5px 10px;
    border: 1px solid #20a0ff;
    color: #fff;
    background-color: #20a0ff;
    font-size: 12px;
    border-radius: 4px;
  }
  .downloadBtn:hover{
    border: 1px solid #4db3ff;
    background-color: #4db3ff;
  }
</style>
<script>
  import modelConfig from '../../../../config/modelConfig.js'
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  import configOperation from './configOperation'
  import cleantypeDialog from './cleantypeDialog'
  import dropdownInput from '../../../Common/business/inputs/honrayDropdownInput'
  import ruleList from '../../../Common/business/rule.vue'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        nullVal: '',
        contentId: '',
        modelId: '',
        fieldShow: false,
        uniqueFieldShow: false,
        report_ruleTit: '',
        curfieldsIndex: 0,
        form: {
          isAll: false,
          is_query: 0,
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          // config: {
          sheet_name: 'sheet1',
          first_import: 2,
          limit_size: 0,
          template_url: '',
          template_name: '',
          title_config: [],
          import_fields: [],
          check_type: 0,
          is_report: '1',
          is_unique: '1',
          report_type: [],
          unique_config: [],
          unique_type: 0,
          unique_over_fields: [], // 覆盖字段
          report_fields: [], // 导入数据的字段（详情）
          report_ruleName: '',
          report_ruleId: 0,
          // },
          type: []  // 支持文件类型
        },
        titleConfigObj: {
          row: '',
          col: '',
          content: ''
        },
        importConfigObj: {
          field_id: '',
          col: '',
          type: '',
          fieldtype_id: 0,
          deal_type: [],
          key_config: {}
        },
        uniqueObj: {
          field_id: ''
        },
        selectFormFields: [], // 下拉框的数据源
        formFieldsLabels: {}, // 显示在输入框的下拉数据源
        formFields: [],
        upload_name: '上传',
        fileUrl: HOST + 'admin/upload',
        fileList: [],
        removeCb: null,
        successCb: null,
        formInputs: [  // 表单控件类型
          { id: 10, name: '单行文本', field_name: 'input' },
          { id: 20, name: '密码', field_name: 'password' },
          { id: 30, name: '多行文本', field_name: 'textarea' },
          { id: 40, name: '单选框', field_name: 'radio' },
          { id: 50, name: '复选框', field_name: 'checkbox' },
          { id: 60, name: '下拉框', field_name: 'select' },
          { id: 70, name: '日期', field_name: 'date' },
          { id: 80, name: '日期时间', field_name: 'datetime' },
          { id: 90, name: '时间', field_name: 'time' },
          { id: 100, name: '富文本', field_name: 'editor' },
          { id: 110, name: '级联选择', field_name: 'link' },
          { id: 120, name: '外键选择', field_name: 'key' },
          { id: 130, name: '子表单', field_name: 'form' },
          { id: 140, name: '文件上传', field_name: 'file' },
          { id: 150, name: '人员选择', field_name: 'people' },
          { id: 160, name: '部门选择', field_name: 'struct' },
          { id: 170, name: '用户信息', field_name: 'userInfo' },
          { id: 180, name: '获取系统时间', field_name: 'dealtime' },
          { id: 190, name: '字段拓展管理', field_name: 'params' },
          { id: 200, name: '多对多关联', field_name: 'multi_link' },
          { id: 210, name: '图片', field_name: 'photo' },
          { id: 220, name: '子表数据关联', field_name: 'child' },
          { id: 230, name: '接口获取内容', field_name: 'obtain_content' }
        ],
        dealTypes: [
          { name: '全角转半角', id: 10 }
        ],
        tempDealTypes: { 10: { name: '全角转半角', id: 10 }},
        contentTypes: [
          // { name: '全选', id: 10 },
          { name: '导入时间', id: 20 },
          { name: '操作人', id: 30 },
          { name: '导入文件', id: 40 },
          { name: '成功导入数', id: 50 },
          { name: '失败导入数', id: 60 },
          { name: '导入数据是否成功及失败原因（详情）', id: 70 },
          { name: '导入数据的字段（详情）', id: 80 }
        ],
        uniqueTypes: [
          { name: '覆盖选中字段的数据更新', id: 10 },
          { name: '覆盖数据除了为空的导入字段', id: 20 },
          { name: '覆盖所有导入字段', id: 30 },
          { name: '返回给用户编辑确认', id: 40 },
          { name: '导入失败', id: 50 }
        ],
        curConfigData: {}
      }
    },
    methods: {
      handleSelectField(item, index) {
        this.form.import_fields[index]['field_id'] = item.id
        this.fieldChange(index)
      },
      setCleanType(index, dealType) {
        this.form.import_fields[index]['deal_type'] = dealType
        // console.log(index, dealType)
      },
      isAllSelect() {
        if (this.form.isAll) {
          this.form.report_type = [20, 30, 40, 50, 60, 70, 80]
          this.fieldShow = true
        }
      },
      selectCleanType(index) {
        // this.dealTypesSource = this.dealTypes
        this.curfieldsIndex = index
        // console.log(this.curfieldsIndex)
        this.curDealType = this.form.import_fields[index]['deal_type']
        // console.log(this.curDealType)
        this.$refs.cleantype.open()
      },
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.type = res.data.config.type
              this.form.sheet_name = res.data.config.sheet_name
              this.form.is_query = res.data.config.is_query
              this.form.first_import = res.data.config.first_import
              this.form.limit_size = res.data.config.limit_size
              this.form.template_url = res.data.config.template_url
              this.form.template_url = res.data.config.template_url
              this.form.template_name = res.data.config.template_name
              if (this.form.template_url != '') {
                this.fileList.push({ name: this.form.template_name, url: this.form.template_url })
              }
              this.form.title_config = res.data.config.title_config
              this.form.import_fields = res.data.config.import_fields
              this.form.is_unique = res.data.config.is_unique
              this.form.check_type = res.data.config.check_type
              this.form.unique_config = res.data.config.unique_config
              this.form.unique_type = res.data.config.unique_type
              this.form.unique_over_fields = res.data.config.unique_over_fields
              this.form.is_report = res.data.config.is_report
              this.form.report_type = res.data.config.report_type
              this.form.report_ruleId = res.data.config.report_ruleId
              this.form.report_fields = res.data.config.report_fields
              _(this.form.report_type).forEach((res, index) => {
                if (res == 10) {
                  this.form.isAll = true
                  this.form.report_type.splice(index, 1)
                  return
                }
              })

              if (this.form.is_report == '1') {
                _(this.form.report_type).forEach((res) => {
                  if (res == 80) { // 导入数据的字段（详情）
                    this.fieldShow = true
                    return false
                  }
                })
              }
            }
            this.modelId = res.data.model_id
            this.getFormDetail()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      save() {
        this.isLoading = true
        let config = _.cloneDeep(this.form)
        delete config.name
        delete config.rule_name
        delete config.model_name
        let postData = {
          config: config
        }
        this.apiPut(`cms/deals/${this.id}`, '', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
            this.isLoading = false
          }
        })
      },
      getAllfields() {
        // 获取所有字段
        this.isLoading = true
        this.form.import_fields = []
        let cur_import_fields = []
        _(this.formFields).forEach((res) => {
          cur_import_fields.push({ key_config: {}, deal_type: [], col: '', field_id: res.default.field_id, type: res.default.title, fieldtype_id: res.default.type })
        })
        this.form.import_fields = cur_import_fields
        _(this.form.import_fields).forEach((res, index) => {
          this.fieldChange(index)
        })
        this.isLoading = false
      },
      deleteTitleConfig(index) {
        this.form.title_config.splice(index, 1)
      },
      addTitleConfig() {
        let newKey = _.cloneDeep(this.titleConfigObj)
        this.form.title_config.push(newKey)
      },
      deleteImportConfig(index) {
        this.form.import_fields.splice(index, 1)
      },
      addImportConfigObj() {
        let newKey = _.cloneDeep(this.importConfigObj)
        this.form.import_fields.push(newKey)
      },
      getFormDetail() {  // 根据model_id获取表单设计器的数据
        this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            this.formFields = res.data
            let selectFormFields = []
            let formFieldsLabels = {}
            _(this.formFields).forEach((res) => {
              let field = {
                id: res.default.field_id,
                value: res.default.title,
                showTitle: res.default.name + '（' + res.default.title + '）'
              }
              formFieldsLabels[res.default.field_id] = field
              selectFormFields.push(field)
            })
            this.selectFormFields = _.cloneDeep(selectFormFields)
            this.formFieldsLabels = _.cloneDeep(formFieldsLabels)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      exchangePosition(arr, index1, index2) {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
      },
      moveTr(index_, type) {
        let arr = []
        if (type) {
          // 下移
          arr = this.exchangePosition(this.form.unique_config, index_, index_ + 1)
        } else {
          // 上移
          arr = this.exchangePosition(this.form.unique_config, index_, index_ - 1)
        }
        this.listConfigObj.row_stylesheet = arr
      },
      deleteUnique(item, index) {
        this.form.unique_config.splice(index, 1)
      },
      addUnique() {
        let newUnique = _.cloneDeep(this.uniqueObj)
        this.form.unique_config.push(newUnique)
      },
      handleReportTypeChange(value) {
        this.fieldShow = false
        _(value).forEach((res, index) => {
          if (res == 10 || res == 80) {
            this.fieldShow = true
            return false
          }
        })
        if (!this.fieldShow) {
          this.form.report_fields = []
        }
        if (this.form.report_type.length == 7) {
          this.form.isAll = true
        } else {
          this.form.isAll = false
        }
      },
      fieldChange(index) {
        let field_id = this.form.import_fields[index]['field_id']
        _(this.formFields).forEach((rres) => {
          if (rres.default.field_id == field_id) {
            let type = rres.default.type
            _(this.formInputs).forEach((res) => {
              if (res.id == type) {
                let curFields = this.form.import_fields[index]
                curFields.type = res.name
                curFields.fieldtype_id = res.id
                delete curFields.has_config
                if (res.id == 110 && rres.link.type == 10) {
                  curFields.has_config = true
                }
                this.$set(this.form.import_fields, index, curFields)
                return false
              }
            })
            return false
          }
        })
      },
      openRule() {
        this.$refs.ruleList.open()
      },
      clearRule() {
        this.form.report_ruleId = null
        this.form.report_ruleName = ''
      },
      confirmConfigOperation(fieldsForm) {
        this.form.import_fields[this.curConfigData.index]['key_config'] = fieldsForm
      },
      selectRule(id, title_else, title) { // 选择权限
        this.form.report_ruleId = id
        this.form.report_ruleName = title_else
      },
      async getRelativeFormDetail(model_id) {  // 根据model_id获取表单设计器的数据
        let arr = []
        let res = await this.apiGet(`form/models/${model_id}/fields`)
        return this.promiseHandler(arr, res)
      },
      async configOperation(row, index) {
        let modelId = 0
        let foreignSelf = false
        _(this.formInputs).forEach((res) => {
          if (res.name == row.type) {
            switch (res.id) {
              case this.TYPE_FOREIGNKEY:  // 外键
                _(this.formFields).forEach((fres) => {
                  if (fres.key) {
                    if (fres.key.select_status) {
                      // 获取外键关联表单的数据
                      modelId = fres.key.form_model
                    } else {
                      foreignSelf = true
                    }
                    return false
                  }
                })
                break
              case this.TYPE_PERSON: // 人员
                // 获取人员选择的数据
                modelId = 1
                break
              case this.TYPE_STRUCT: // 部门
                // 获取部门选择的数据
                modelId = 2
                break
              case this.TYPE_CASCADER: // 级联
                _(this.formFields).forEach((fres) => {
                  if (fres.link) {
                    modelId = fres.link.model_id
                    return false
                  }
                })
                break
            }
            return false
          }
        })
        if (foreignSelf) {
          this.curConfigData.fields = _.cloneDeep(this.formFields)
        } else {
          this.curConfigData.fields = await this.getRelativeFormDetail(modelId)
        }
        this.curConfigData.title = row.type
        this.curConfigData.index = index
        this.curConfigData.form = this.form.import_fields[index]['key_config'] // ['fields']
        this.$refs.configOperation.openDialog()
      },
      beforeUpload(file) {
        let len = file.name.toString().split('.').length
        let type = file.name.toString().split('.')[len - 1]
        if (type == 'xlsx') {
          return true
        } else {
          _g.toastMsg(this, 'error', '上传的文件格式不对，需要上传.xlsx文档')
          return false
        }
      },
      init() {
        this.removeCb = (file, fileList) => {
          this.fileList = fileList
          document.getElementsByName('file')[0].value = null
          this.upload_name = '上传'
        }
        this.successCb = (res, file, fileList) => {
          if (res.code == 200) {
            if (fileList.length > 1) {
              fileList.shift()
            }
            this.form.template_url = HOST + res.data
            this.form.template_name = fileList.name
            // this.form.downFile = {
            //   url: HOST + res.data,
            //   name: fileList[0].name,
            //   source_url: res.data
            // }
            this.fileList = fileList
            this.upload_name = '重新上传'
          } else {
            fileList = []
            _g.toastMsg(this, 'error', '上传文件失败')
          }
        }
      },
      isStruct(id) {
        if (id == 160) {
          return true
        } else {
          return false
        }
      },
      isUser(id) { // 人员选择
        if (id == 150) {
          return true
        } else {
          return false
        }
      },
      isForeign(id) { // 外键
        if (id == 120) {
          return true
        } else {
          return false
        }
      },
      isKey(id) { // 级联
        if (id == 110) {
          return true
        } else {
          return false
        }
      },
      goback() {
        router.go(-1)
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
      this.init()
      // this.restaurants = this.loadAll()
    },
    components: {
      commonConfig,
      configOperation,
      dropdownInput,
      cleantypeDialog,
      ruleList
    },
    watch: {
      'form.is_unique'() {
        if (this.form.is_unique == '0') {
          this.form.check_type = 0
          this.form.unique_config = []
          this.form.unique_type = []
          this.form.unique_over_fields = []
        }
      },
      'form.unique_type'() {
        this.uniqueFieldShow = false
        if (this.form.unique_type == 10) {
          this.uniqueFieldShow = true
        } else {
          this.form.unique_over_fields = []
        }
      },
      'form.is_report'() {
        if (this.form.is_report == '0') {
          this.form.report_type = []
          this.form.report_fields = []
          this.form.report_ruleId = 0
        }
      }
    },
    mixins: [http, flowConfig, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// importConfig.vue?034083d8